<template>
    <div>
        <div class="sub-title">等级说明</div>
        <div class="title">{{ 'K' + data.level + ' ' + data.title }}</div>
        <div class="rule-box">
            <p class="unlock_tip">需要达到 {{ data.needScore }} 创作分</p>
            <p class="rule-desc">{{ data.description }}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'benefit-intro',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            imgUrl: '',
        };
    },
    methods: {
        onClickImg(url) {
            console.log('xxxxonClickImg', url);
            this.imgUrl = url;
            this.showImgDetail = true;
        },
    },
};
</script>

<style lang="less" scoped>
.sub-title {
    font-weight: 400;
    font-size: 0.22rem;
    line-height: 0.32rem;
    color: rgba(255, 255, 255, 0.4);
}
.title {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 500;
    font-size: 0.42rem;
    line-height: 0.58rem;
    color: rgba(255, 255, 255, 0.9);
    margin-top: 0.2rem;
}
.rule-title {
    font-weight: 500;
    font-size: 0.26rem;
    line-height: 0.36rem;
    color: #ffffff;
    margin-top: 0.66rem;
}
.rule-desc-box {
    margin-top: 0.18rem;
}
.rule-desc {
    font-weight: 400;
    font-size: 0.26rem;
    line-height: 0.36rem;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 0.3rem;
}
.rule-img {
    width: 3rem;
    height: 3rem;
    object-fit: contain;
}
.modal {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.7);
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}
.unlock_tip {
    font-size: 0.22rem;
    line-height: 0.3rem;
    color: rgba(255, 255, 255, 0.9);
    background: rgba(255, 255, 255, 0.08);
    border-radius: 0.2rem;
    padding: 0.06rem 0.2rem;
    display: inline-block;
    margin-top: 0.3rem;
}
.rule-box {
    position: relative;
    padding-bottom: 0.4rem;
    &::after {
        content: '';
        display: block;
        position: absolute;
        height: 0.01rem;
        bottom: 0;
        width: 100%;
        background: rgba(255, 255, 255, 0.08);
    }
}
</style>
